import {
  PROJECT_SELECT_FETCH_STARTED,
  PROJECT_SELECT_FETCH_SUCCEEDED,
  PROJECT_SELECT_FETCH_FAILED,
  PROJECT_SELECT_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { fetchJson } from '#action/fetch';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();
export const fetchSelectProjects = (filter, hideUnexpired) => async dispatch => {
  try {
    abortController.abort();
    dispatch({
      type: PROJECT_SELECT_FETCH_STARTED
    });

    const params = new URLSearchParams({
      limit: 100,
      order: 'asc',
      orderBy: 'parent',
      modules: true
    });

    if (hideUnexpired) {
      params.set('unexpired', 1);
    }

    if (filter) {
      params.set('filter', filter);
      params.set('filterBy', 'title');
      if (filter.length === 1) return;
    }

    const url = webPortalApi.buildApiUrl(`project?${params.toString()}`);
    abortController = new AbortController();
    const { signal } = abortController;

    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });

    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const users = await res.json() ?? [];

    dispatch({
      type: PROJECT_SELECT_FETCH_SUCCEEDED,
      payload: users
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: PROJECT_SELECT_FETCH_FAILED,
      error: e
    });
  }
};

export const fetchSelectDirectProjects = (filter, hideUnexpired) => async (dispatch, getState) => {
  try {
    abortController.abort();
    dispatch({
      type: PROJECT_SELECT_FETCH_STARTED
    });

    const params = new URLSearchParams({
      limit: 100,
      order: 'asc',
      orderBy: 'parent',
      modules: true
    });

    const { id: userId } = getState().account;
    const userUrl = webPortalApi.buildApiUrl(`users?ids=${userId}`);
    const [userRes] = await fetchJson(userUrl);

    if (userRes) {
      const { directProjects } = userRes;
      const directIds = directProjects.join(',');
      params.set('ids', directIds);
    }

    if (hideUnexpired) {
      params.set('unexpired', 1);
    }

    if (filter) {
      params.set('filter', filter);
      params.set('filterBy', 'title');
      if (filter.length === 1) return;
    }

    const url = webPortalApi.buildApiUrl(`project?${params.toString()}`);
    abortController = new AbortController();
    const { signal } = abortController;

    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });

    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const users = await res.json() ?? [];

    dispatch({
      type: PROJECT_SELECT_FETCH_SUCCEEDED,
      payload: users
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: PROJECT_SELECT_FETCH_FAILED,
      error: e
    });
  }
};

export const clearSelectProjects = () => dispatch => {
  abortController.abort();
  dispatch({
    type: PROJECT_SELECT_CLEAR
  });
};
